module.exports = __webpack_public_path__ + "static/media/logo-footer.cd874838.png";